import { Navigate, useLocation } from 'react-router-dom';
import { legacyWeightResearchLocation } from '@/lib/researchWorkspace';

export default function LegacyWeightResearchRedirect() {
  const location = useLocation();
  return <Navigate replace to={legacyWeightResearchLocation(location.search)} />;
}
